import { jwtDecode } from "jwt-decode";

const isTokenValid = (token: string): boolean => {
  try {
    const decodedToken = jwtDecode<{ exp: number }>(token);
    const currentTime = Math.floor(Date.now() / 1000);
    return decodedToken.exp > currentTime;
  } catch {
    return false;
  }
};

export default isTokenValid;
